"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceTransparencyWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PriceTransparencyWidget_1 = require("../../../../widgets/annual/motor/priceTransparency/PriceTransparencyWidget");
/**
 * Wrapper for passing props from journey interaction to PriceTransparencyWidget.
 */
var PriceTransparencyWrapper = /** @class */ (function (_super) {
    __extends(PriceTransparencyWrapper, _super);
    function PriceTransparencyWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceTransparencyWrapper.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(PriceTransparencyWidget_1.PriceTransparencyWidget, { vehicles: this.props.interaction.vehicles, isMultipleDrivers: this.props.interaction.additionalDrivers.length > 0 });
    };
    return PriceTransparencyWrapper;
}(plugin_journey_1.WidgetBase));
exports.PriceTransparencyWrapper = PriceTransparencyWrapper;
//# sourceMappingURL=PriceTransparencyWrapper.js.map